import * as uuid from 'uuid';

const generateKey = () => {
    const key: string = uuid.v4().toString(); 
    return key;
}

export default generateKey;